import { render, staticRenderFns } from "./TextareaField.vue?vue&type=template&id=d323ff32&scoped=true&"
import script from "./TextareaField.vue?vue&type=script&lang=js&"
export * from "./TextareaField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d323ff32",
  null
  
)

export default component.exports